module.exports = __webpack_public_path__ + "static/media/return.3283721a.svg";